<template lang="pug">
form-item-wrapper(v-bind="bind", :showMessage="false", :rules="rules", :class="formItemClass")
  user-list(v-if="singleUser", v-bind="singleBind", @delete="removeUser", :disabled="!isEdit", @click-item="clickUser")
  span(v-else-if="fieldModel") #[i.el-icon-loading] 正在加载
  el-button(v-else-if="isEdit", type="text", icon="el-icon-plus", @click="open") 选择
  span(v-else) (无)
</template>
<script>
import { mapVFAssignField } from "@/CommonDP/VForm/utils";
import { getUserById, user_cache, USER_ENUM } from "./utils.js";
import User from "./index.vue";
export default {
  extends: User,
  data() {
    return { userCache: user_cache, defaultValue: "" };
  },
  computed: {
    ...mapVFAssignField(["assignToName", "assignToUserName"]),
    singleUser() {
      const { fieldModel, userCache } = this;
      return userCache[fieldModel];
    },
    singleBind() {
      const { userBind, singleList } = this;
      return {
        ...userBind,
        list: singleList,
        line: "inline"
      };
    },
    singleList() {
      const { singleUser } = this;
      return singleUser ? [singleUser] : [];
    },
    vmDefaultValue() {
      const {
        options: { defaultUser, defaultUserType }
      } = this;
      const userList = defaultUserType === USER_ENUM.cur_user ? [this.$store.state.user.userInfo] : defaultUser;
      return userList[0]?.userId || "";
    },
    userList() {
      return this.singleList;
    }
  },
  watch: {
    // 监听当前值获取获取用户信息
    fieldModel: {
      immediate: true,
      handler(id) {
        id && getUserById(id);
      }
    }
  },
  methods: {
    async removeUser() {
      this.preventDesign();
      await this.$confirm("确认删除?", "警告", { type: "warning" });
      this.updateValue([]);
    },
    // 主值变化的时候,触发方法
    async withUpdate() {
      const { fieldModel } = this;
      let username = "";
      let name = "";
      if (fieldModel) {
        // 等待加载完成
        const user = await getUserById(fieldModel);
        name = user.name;
        username = user.username;
      }
      // 添加延迟,度过禁用修改时间
      await this.$nextTick();
      this.assignToUserName = username;
      this.assignToName = name;
    },
    updateValue(userList) {
      const [user] = userList;
      this.fieldModel = user ? user.userId : "";
    },
    clickUser() {
      if (this.isEdit) this.open();
    },
    getSelection() {
      const { fieldModel, singleUser: raw } = this;
      return fieldModel ? [{ raw, id: fieldModel, label: raw.name }] : [];
    },
    // 替换多人选择
    updateAssign() {}
  }
};
</script>
